import React from "react";
import { FormControl, FormGroup, Button, Glyphicon, InputGroup } from "react-bootstrap";
import ajax from "../../lib/ajax.js";
import context from "../../lib/context.js";

export default class StaffAutoComplete extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            items: [],
            selectedText: ''
        };

        this.onKeyUp = this.onKeyUp.bind(this);
        this.onSelect = this.onSelect.bind(this);
        this.onClick = this.onClick.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.dropdownContent = null;
        this.getHighlightedText = this.getHighlightedText.bind(this);
        this.search = null;
        this.input = null;
        this.onSearchClick = this.onSearchClick.bind(this);
    }    

    componentDidMount() {
        this.setState({
            items: this.props.items,
            selectedText: this.props.defaultValue
        });
    }

    componentWillReceiveProps(currProps) {
        this.dropdownContent.className = this.dropdownContent.className.replace('show', '');
    }

    onClick() {
        if (this.dropdownContent.className.indexOf('show') > -1) {
            this.dropdownContent.className = this.dropdownContent.className.replace('show', '');
        }
        else {
            this.dropdownContent.className = this.dropdownContent.className + ' show'; 
        }
    }

    onKeyUp(event) {
        let value = event.target.value.trim().toLowerCase();
        let items = this.props.items.filter(x => x.fullName.trim().toLowerCase().indexOf(value) > -1);

        this.setState({
            items: items
        });
    }

    onSelect(item) {
        if (this.props.onChange) {
            if (item == null) {
                this.props.onChange('__All Direct Reports', this.props.onSearch);
            }
            else {
                let value = `${item.peopleId}__${item.fullName}`;
                this.props.onChange(value, this.props.onSearch);
            }
        }

        this.setState({
            selectedText: item == null ? 'All Direct Reports' : item.fullName
        });

        this.dropdownContent.className = this.dropdownContent.className.replace('show', '');
    }

    onBlur() {
        const self = this;

        setTimeout(function() {
            var buttonFocused = $('#' + self.props.id + '-button').is(':focus');
            var inputFocused = $('#' + self.props.id + '-input').is(':focus');
            
            if (buttonFocused == false && inputFocused == false) {
                self.dropdownContent.className = self.dropdownContent.className.replace('show', '');
            }

            setTimeout(function() {
                if (inputFocused == true) {
                    self.search.className = 'glyphicon glyphicon-remove-sign';
                }
                else {
                    self.search.className = 'glyphicon glyphicon-search';
                }
            }, 100);
        }, 10);
    }

    getHighlightedText(text) {
        var textToSearch = $('#' + this.props.id + '-input').val().trim().toLowerCase();
        var result = text;

        if (textToSearch != '') {
            result = result.replace(RegExp(textToSearch + "(?![^<>]*>)", "gi"), function(e) {
                return '<b>' + e + '</b>';
            });
        }
        
        return result;
    }

    onSearchClick() {
        const self = this;

        if (this.search.className.indexOf('glyphicon-remove-sign') > -1) {
            setTimeout(function() {
                $('#' + self.props.id + '-input').val('');
                var items = JSON.parse(JSON.stringify(self.props.items));

                self.setState({
                    items: items
                });

                $('#' + self.props.id + '-input').focus();
                self.search.className = 'glyphicon glyphicon-remove-sign';
            }, 10);
        }
        else {
            setTimeout(function() {
                $('#' + self.props.id + '-input').focus();
            }, 10);
        }
    }

    render() {
        var rows = [];
        
        const self = this;

        this.state.items.map(function (item, i) {
            let p = item; 
            rows.push(<a key={p.peopleId} href="#" onMouseDown={(evt) => { evt.preventDefault(); self.onSelect(item); return false; }} className={this.state.selectedText}>
                    <div className="item-selected">
                        {
                            this.state.selectedText == item.fullName ?
                            <div className="glyphicon glyphicon-ok"></div> :
                            <div></div>
                        }
                    </div>
                    <div className="item-name" dangerouslySetInnerHTML={ { __html: self.getHighlightedText(p.fullName) } }></div><div className="item-count">{(p.approverId == null ? '' : '- ' + p.staffCount + ' Staff')}</div>
                </a>);
        }, this);

        return (
            <div className="ap-staff-autocomplete">
                <button id={this.props.id + '-button'} className="dropdown" onClick={this.onClick} onBlur={this.onBlur}>
                    {this.props.value}
                    <Glyphicon glyph="" bsClass="glyphicon glyphicon-menu-down"></Glyphicon>
                </button>
                <div id={this.props.id + '-dropdown-content'} className="dropdown-content" ref={ref => this.dropdownContent = ref}>
                    <FormGroup className="form-group" validationState={null}>
                        <InputGroup>
                            <FormControl
                                id={this.props.id + '-input'}
                                type="text"
                                onKeyUp={this.onKeyUp}
                                className="input"
                                placeholder="Type staff's name"
                                onBlur={this.onBlur}
                                ref={ref => this.input = ref}
                                />
                            <InputGroup.Addon>
                                <div id={this.props.id + '-remove'} className="glyphicon glyphicon-search" ref={ref => this.search = ref} onMouseDown={this.onSearchClick}></div> 
                            </InputGroup.Addon>
                        </InputGroup>
                    </FormGroup>
                    <div className="select-instruction">All Staff:</div>
                    <div id={this.props.id + '-items-container'} className="items-container">
                        <a href="#" onMouseDown={(evt) => { evt.preventDefault(); self.onSelect(null); return false; }} className={"item"}>
                            <div className="item-selected">
                                {
                                    this.state.selectedText == 'All Direct Reports' ?
                                    <div className="glyphicon glyphicon-ok"></div> :
                                    <div></div>
                                }
                            </div>
                            <div className="item-name">
                                All Direct Reports
                            </div>
                        </a>
                        {rows}
                    </div>
                </div>
            </div>
        );
    }
}